<template>
  <client-only>
    <div v-if="isDesktop" class="desktop-issue-components">
      <div class="issue-item" v-for="(item, index) in folds">
        <strong class="collapseTitle" v-if="item.questionTitle">{{ formatText(item.questionTitle) }}</strong>
        <div class="collapseContent" v-for="(contentItem, i) in item.contents">
          {{ formatText(contentItem) }}
        </div>
      </div>
    </div>

    <div v-else class="mobile-issue-components">
      <Collapse v-for="(item, index) in folds" :key="index" class="issue-item">
        <template #title="{isShow}">
          <div class="collapseTitle">
            <span>{{ formatText(item.questionTitle) }}</span>
            <i class="iconfont icon-icon_arrowsdown" :class="`${ isShow ? 'active' : 'unactive'}`"/>
          </div>
        </template>
        <template #content>
          <div>
            <div v-for="(contentItem, i) in item.contents" :key="i" class="collapseContent">
              {{ formatText(contentItem) }}
            </div>
          </div>
        </template>
      </Collapse>
    </div>
  </client-only>
</template>

<script lang="ts" setup>
import { onMounted, defineEmits } from "vue";
import { useI18n } from 'vue-i18n'
import { useRouter, useRoute } from 'vue-router'
import Collapse from './Collapse/index.vue'
import { storeToRefs } from "pinia";
import useBasicStore from '~/store/modules/basic'


import {
  getteamQAConfigList,
} from '~/config/QA'

const router = useRouter()
const route = useRoute()
const basicStore = useBasicStore()
const { isChina } = storeToRefs(basicStore)
const viewport = useViewport()
const isDesktop = computed(() => viewport.breakpoint?.value.includes('desktop'))
// 定义 folds 的类型
interface FoldItem {
  questionTitle: string;
  contents: string[];
}

interface Props {
  title?: string
  subTitle?: [string]
  type: number  // 1 编辑页面
  translateType?: number
}
const props = defineProps<Props>()
let call = defineEmits(["onFoldIndex"])
const { t } = useI18n()
let activeName = ref()
let folds = ref<FoldItem[]>([])
let selectMap = ref({})

watch(
  () => isChina.value,
  () => {
    updataIssue()
  },
  {
    deep: true
  }
)
watch(
  () => props.translateType,
  () => {
    updataIssue()
  },
  {
    deep: true
  }
)

function formatText(text: string): string {
  if (!text) return ''
  // 将字符串中的 \n 转换为真正的换行符
  return text.replace(/\\n/g, '\n')
}

function updataIssue() {

  folds.value = []

  if (!isChina.value) {
    if (props.type == 1) {
      // 团队管理 - 常见问题
      folds.value = getteamQAConfigList(t);
    }
  } else {
    if (props.type == 1) {
      folds.value = getteamQAConfigList(t);
    }

  }
}

onMounted(() => {
  if (props.subTitle) {
    activeName.value = props.subTitle[0]
  }

  updataIssue()
})
</script>

<style lang="scss" scoped>
@use "./index.scss" as *;
@use "./mobile.scss" as *;
</style>
